import { render, staticRenderFns } from "./HealthTips.vue?vue&type=template&id=398134ce&"
import script from "./HealthTips.vue?vue&type=script&lang=js&"
export * from "./HealthTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports